export const QueryStaleTime = {
  ZERO: 0, // for the data that we don't want to cache
  SHORT: 1000 * 60 * 1, // 1 minute, for some data that changes frequently
  MEDIUM: 1000 * 60 * 5, // 5 minutes, default value
  LONG: 1000 * 60 * 10, // 10 minutes, for the data that changes rarely
  VERY_LONG: 1000 * 60 * 30, // 30 minutes, for the filter options
};
